import React from 'react';
import Axios from 'axios';
import { Link } from 'react-router-dom';

class Admin_Master extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
    	leaguesCount: 0,
    	seasonsCount: 0,
    	teamsCount: 0,
			playersCount: 0,
			gamesCount: 0,
			usersCount: 0,
			membersCount: 0,
		};
		// this.dummyfunction = this.dummyfunction.bind(this);
	}

	getCounts() {

		var _this = this;
		Axios.get('/api/leagues/count').then(function (responseLeagues) {
		Axios.get('/api/seasons/count').then(function (responseSeasons) {
		Axios.get('/api/teams/count').then(function (responseTeams) {
		Axios.get('/api/players/count').then(function (responsePlayers) {
		Axios.get('/api/results/gameResults/count').then(function (responseGames) {
		Axios.get('/api/users/count').then(function (responseUsers) {
		Axios.get('/api/users/countMembers').then(function (responseMembers) {
			
			_this.setState({
				leaguesCount: responseLeagues.data.count,
				seasonsCount: responseSeasons.data.count,
				teamsCount: responseTeams.data.count,
				playersCount: responsePlayers.data.count,
				gamesCount: responseGames.data.count,
				usersCount: responseUsers.data.count,
				membersCount: responseMembers.data.count,
			});
		});
		});
		});
		});
		});
		});
		});
	}

	componentDidMount() {
		this.getCounts();
	}

  render() {
	  // console.log('AdminMaster: render');
    return (
      <div>
				<h3>*** MASTER ***</h3>

        <div className="row">
        <div className="col-md-6 col-xs-6">
				<h5>Sommaire Statelo</h5>
        <div className="row col-md-12 col-xs-12">
				<ul>
					<li>Ligues: {this.state.leaguesCount}</li>
					<li>Saisons: {this.state.seasonsCount}</li>
					<li>Équipes: {this.state.teamsCount}</li>
					<li>Joueurs: {this.state.playersCount}</li>
					<li>Parties: {this.state.gamesCount}</li>
					<li>Utilisateurs: {this.state.usersCount}</li>
					<li>Membres: {this.state.membersCount}</li>
				</ul>
        </div>
        </div>
        </div>

        <div className="row col-md-6 col-xs-6">
 
				<h5>Menu Master</h5><br/>
        <div className="row col-md-12 col-xs-12">
        <ul>
          <li><Link to="/admsafe/leagues">Ligues</Link></li>
          <li><Link to="/admsafe/seasons">Saisons</Link></li>
          <li><Link to="/admsafe/users">Utilisateurs</Link></li>
          <li><Link to="/admsafe/usersInvoiceDetails">Utilisateurs (Facturation)</Link></li>
          <li><Link to="/admsafe/memberActiveUsers">Membres Statelo</Link></li>
          <li><Link to="/admsafe/userEvents">Événements Utilisateurs</Link></li>
          <li><Link to="/admsafe/connections">Connections</Link></li>
          <li><Link to="/admsafe/adminPubEvents">Pub Events</Link></li>
          <li><Link to="/admsafe/mergePlayers">Fusion de joueurs</Link></li>
        </ul>
        </div>
      </div>
      </div>
    );
  }

}

export default Admin_Master;
